module.exports = __webpack_public_path__ + "img/TRN Web Banner.74571426.png";